import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const categories = ['All', 'LED Signs', 'ACP & Boards', 'Outdoor', 'Interior', 'Digital'];

const products = [
  { cat: 'LED Signs', name: 'Channel Letter Signs', desc: 'Individually crafted 3D letters with LED illumination. Available in front-lit, back-lit and combo configurations.', img: 'https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=600&q=80' },
  { cat: 'ACP & Boards', name: 'ACP Sign Boards', desc: 'Premium aluminium composite panel boards with UV digital printing and laser-cut lettering.', img: 'https://images.unsplash.com/photo-1611095564985-4b6e372c3bfb?w=600&q=80' },
  { cat: 'Outdoor', name: 'Hoardings', desc: 'Large-format flex or backlit hoardings for high-traffic outdoor locations.', img: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600&q=80' },
  { cat: 'Interior', name: 'Reception Signs', desc: 'Bespoke reception wall signs with 3D logos, backlit panels and premium finishes.', img: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=600&q=80' },
  { cat: 'Digital', name: 'LED Video Wall', desc: 'Modular indoor/outdoor LED screens for dynamic digital advertising content.', img: 'https://images.unsplash.com/photo-1579873948173-b236b5fc5c17?w=600&q=80' },
  { cat: 'Interior', name: 'Wayfinding Totems', desc: 'Tall pylon signs and directional totems for offices, hospitals and campuses.', img: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&q=80' },
  { cat: 'LED Signs', name: 'Neon Signs', desc: 'Custom flex-neon and glass neon signs in any shape, text or logo for modern branding.', img: 'https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?w=600&q=80' },
  { cat: 'Outdoor', name: 'Unipole Structures', desc: 'Single-pole billboard structures placed at prime highway and city locations.', img: 'https://images.unsplash.com/photo-1593508512255-86ab42a8e620?w=600&q=80' },
  { cat: 'ACP & Boards', name: 'Frosted Film Partitions', desc: 'Decorative frosted films and glass decals for office partitions and windows.', img: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&q=80' },
];

function Products() {
  const [active, setActive] = useState('All');
  const filtered = active === 'All' ? products : products.filter(p => p.cat === active);

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <i className="fas fa-chevron-right" />
            <span>Products</span>
          </div>
          <h1 className="page-hero-title">
            Our <span>Products</span>
          </h1>
          <p className="section-desc light" style={{ marginTop: 16 }}>
            Browse our full range of signage and advertising products crafted for every industry.
          </p>
        </div>
      </div>

      <section style={{ padding: '80px 0', background: '#fff' }}>
        <div className="container">
          {/* Filters */}
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 48 }}>
            {categories.map(cat => (
              <button
                key={cat}
                onClick={() => setActive(cat)}
                style={{
                  padding: '10px 22px',
                  borderRadius: 4,
                  border: `2px solid ${active === cat ? 'var(--primary)' : 'var(--gray-200)'}`,
                  background: active === cat ? 'var(--primary)' : 'transparent',
                  color: active === cat ? 'var(--secondary)' : 'var(--text-mid)',
                  fontFamily: 'var(--font-condensed)',
                  fontSize: '13px',
                  fontWeight: 700,
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                }}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Products Grid */}
          <div className="products-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
            {filtered.map((p, i) => (
              <div className="product-card" key={i}>
                <img src={p.img} alt={p.name} loading="lazy" />
                <div className="product-overlay">
                  <div className="product-tag">{p.cat}</div>
                  <div className="product-name" style={{ fontSize: '1.4rem' }}>{p.name}</div>
                  <p className="product-desc" style={{ maxHeight: '100px', opacity: 1 }}>{p.desc}</p>
                  <Link to="/contact" className="product-arrow" style={{ opacity: 1, transform: 'none', marginTop: 12 }}>
                    Get Quote <i className="fas fa-arrow-right" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-inner">
            <div>
              <h2 className="cta-title">Don't See What You <span>Need?</span></h2>
              <p className="cta-desc">We create fully custom signage solutions. Tell us your requirements and we'll build it.</p>
            </div>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-primary">
                Custom Inquiry <i className="fas fa-arrow-right" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          .products-grid { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 1024px) and (min-width: 769px) {
          .products-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
      `}</style>
    </>
  );
}

export default Products;
